const STEP_MINUTES = 5;
const MIN_MINUTES = 5;
const MAX_MINUTES = 120;

/**
 * Displayed session-duration range for AI-moderated interviews, derived from
 * the stored upper-bound minutes. All surfaces (web + emails) must use this
 * so they render the same range. `low === high` at the 5-minute floor.
 */
export function interviewDurationRange(storedMinutes: number): {
  low: number;
  high: number;
} {
  const stepped = Math.ceil(storedMinutes / STEP_MINUTES) * STEP_MINUTES;
  const high = Math.min(MAX_MINUTES, Math.max(MIN_MINUTES, stepped));
  // Longer sessions vary more, so the spread widens with the upper bound.
  const spread = high <= 20 ? 5 : high <= 45 ? 10 : high <= 90 ? 15 : 20;
  return { low: Math.max(MIN_MINUTES, high - spread), high };
}
